<template>
  <v-app>
   <core-migration-banner />

   <core-filter v-if="showExtras" />

   <core-toolbar v-if="showExtras"/>

   <core-drawer v-if="showExtras" />

    <core-view  />
  </v-app>
</template>
<script>
export default {
  data: function(){
    return{
      showExtras: false,
    }
  },
  watch:{
    '$route' (to, from) {
         
         if (to.matched.some(record => record.meta.requiresAuth)){
           
           this.showExtras = true
         }
         else{
           this.showExtras = false
         }
    }
  }
}
</script>
<style lang="scss">
@import '@/styles/index.scss';

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}
</style>
